module.exports = __webpack_public_path__ + "img/2015-founded.dbf76568.jpg";